import { nonEmpty } from '@shared/phone/normalize-phone';

/** THE "does this contact have a number" test: a blank or whitespace-only value is no number. */
export function hasPhone(value: string | null | undefined): value is string {
  return nonEmpty(value) !== null;
}
